/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description PropertyManagement
 */

import { routesConstants } from '@zcode/zumper-routes'
import * as React from 'react'
import { TRACK_USER_MENU_ACTION } from '../../../constants'
import { useUserMenuContext } from '../../../module/context/UserMenuContext'
import { getPostListingLink } from '../../../utils/getPostListingLink'
import { MenuSection, UserMenuLinkRow } from '../SharedComponents'

export const PropertyManagement = () => {
  const { dispatchTrackUserMenuClick, isLoggedIn, toolsActivated } = useUserMenuContext()
  const isProUser = isLoggedIn && toolsActivated
  const postListingLink = getPostListingLink({ isProUser })
  const onPostListingClick = () => dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.POST_LISTING)
  const onAdvertiseClick = () => dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.ADVERTISE)
  const onManageListingsClick = () =>
    dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.MANAGE_LISTINGS)
  return (
    <MenuSection heading="Property management">
      {!isProUser && (
        <React.Fragment>
          <UserMenuLinkRow href={postListingLink} onClick={onPostListingClick}>
            Post a listing
          </UserMenuLinkRow>
          <UserMenuLinkRow href={routesConstants.ADVERTISE_URL} onClick={onAdvertiseClick}>
            Advertise with Zumper
          </UserMenuLinkRow>
        </React.Fragment>
      )}
      {isProUser && (
        <UserMenuLinkRow href="/manage/properties" onClick={onManageListingsClick}>
          Manage your listings
        </UserMenuLinkRow>
      )}
    </MenuSection>
  )
}
